import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useLocation, useNavigate } from 'react-router-dom';

// Tela de sucesso pós-aceite do termo de adesão. Mensagem limpa de conclusão.
// O CTA opcional de "contrato formal" foi removido em 2026-07-10 — o fluxo de
// contrato formal (/contrato-formal/:id) continua existindo no código, mas não
// é mais oferecido aqui. Ver docs/frontend-cta-contrato-formal-no-sucesso.md
// para o histórico da decisão anterior.
// Modo ADITIVO (navigate state `isAditivo`): texto de recurso adicional
// contratado; nunca oferece contrato formal (o termo principal já cobre).
export default function CadastroSucesso() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAditivo = location.state?.isAditivo === true;
  const nomeRecurso: string = location.state?.nomeRecurso || '';

  if (isAditivo) {
    return (
      <div className="min-h-screen bg-muted/30">
        <header className="py-4 bg-white border-b border-border">
          <div className="container px-4 mx-auto">
            <div className="flex items-center">
              <img src="/brand/logo-secundario.svg" alt="dgenny" className="h-9" />
            </div>
          </div>
        </header>

        <main className="container px-4 mx-auto py-12 md:py-16">
          <div className="max-w-2xl mx-auto">
            <Card className="p-10 border-border shadow-sm text-center rounded-3xl">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-brand-rosa/30 rounded-full flex items-center justify-center">
                  <CheckCircle2 size={44} className="text-brand-roxo" />
                </div>
              </div>

              <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul mb-3">
                Recurso adicional contratado
              </h1>
              {nomeRecurso && (
                <p className="text-lg text-brand-roxo font-semibold mb-8">{nomeRecurso}</p>
              )}

              <div className="text-brand-azul/75 mb-10 space-y-3 leading-relaxed">
                <p>O aceite do termo do recurso adicional já está registrado.</p>
                <p>
                  Nosso time entra em contato nas próximas horas para ativar o recurso na sua conta.
                </p>
                <p className="text-sm text-brand-azul/55">
                  Você também vai receber um e-mail com a confirmação e os próximos passos.
                </p>
              </div>

              <div className="border-t border-border my-6" />

              <div className="bg-muted/60 rounded-2xl p-5 mb-8">
                <p className="text-sm text-brand-azul/60">Dúvida agora?</p>
                <p className="text-brand-azul font-semibold mt-1">compre.ai@dgenny.com.br</p>
              </div>

              <Button
                onClick={() => navigate('/')}
                className="bg-brand-roxo hover:bg-brand-roxo/90 text-white py-3 px-8 rounded-full font-semibold"
              >
                Voltar para a home
              </Button>
            </Card>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-muted/30">
      <header className="py-4 bg-white border-b border-border">
        <div className="container px-4 mx-auto">
          <div className="flex items-center">
            <img src="/brand/logo-secundario.svg" alt="dgenny" className="h-9" />
          </div>
        </div>
      </header>

      <main className="container px-4 mx-auto py-12 md:py-16">
        <div className="max-w-2xl mx-auto">
          <Card className="p-10 border-border shadow-sm text-center rounded-3xl">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-brand-rosa/30 rounded-full flex items-center justify-center">
                <CheckCircle2 size={44} className="text-brand-roxo" />
              </div>
            </div>

            <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul mb-3">
              Cadastro concluído
            </h1>
            <p className="text-lg text-brand-roxo font-semibold mb-8">
              Bem-vindo à dgenny.
            </p>

            <div className="text-brand-azul/75 mb-10 space-y-3 leading-relaxed">
              <p>Seus dados já estão no nosso sistema.</p>
              <p>
                Nosso time entra em contato nas próximas horas para avançar com a contratação e a configuração do plano.
              </p>
              <p className="text-sm text-brand-azul/55">
                Você também vai receber um e-mail com os próximos passos.
              </p>
            </div>

            <div className="border-t border-border my-6" />

            <div className="bg-muted/60 rounded-2xl p-5 mb-8">
              <p className="text-sm text-brand-azul/60">Dúvida agora?</p>
              <p className="text-brand-azul font-semibold mt-1">compre.ai@dgenny.com.br</p>
            </div>

            <Button
              onClick={() => navigate('/')}
              className="bg-brand-roxo hover:bg-brand-roxo/90 text-white py-3 px-8 rounded-full font-semibold"
            >
              Voltar para a home
            </Button>
          </Card>

          <div className="text-center text-sm text-brand-azul/50 mt-6">
            <p>Obrigado por escolher a dgenny.</p>
          </div>
        </div>
      </main>
    </div>
  );
}
